/*
 * JavaScript custom du thème (chargé en plus du thème de base).
 */

(function() {

  // Fix affichage de la valeur du select de taille : la valeur est dans
  // un <span class="select-popout__toggle-value">, pas un TEXT_NODE du button.
  var PopoutSelectClass = customElements.get('popout-select');
  if (PopoutSelectClass) {
    PopoutSelectClass.prototype.replaceTextContent = function(elem, newContent) {
      var valueSpan = elem.querySelector('.select-popout__toggle-value');
      if (valueSpan) {
        valueSpan.textContent = newContent;
        return;
      }
      Array.from(elem.childNodes).forEach(function(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          node.textContent = newContent;
        }
      });
    };
  }

  const productEnquireBtn = document.querySelector('[data-product-enquire]');
  if(productEnquireBtn) {
    productEnquireBtn.addEventListener('click', function(event) {
      event.preventDefault();
      const productEnquireForm = document.querySelector('[data-product-form-enquire]');
      productEnquireForm.classList.add('active');
      productEnquireBtn.classList.add('hidden');

      const productEnquireFormSuccess = document.querySelector('[data-product-enquire-success]');
      productEnquireFormSuccess.parentElement.removeChild(productEnquireFormSuccess);
    })
  }

  const productNotifyBtn = document.querySelector('[data-product-notify]');
  if(productNotifyBtn) {
    productNotifyBtn.addEventListener('click', function(event) {
      event.preventDefault();
      const productNotifyForm = document.querySelector('[data-product-form-notify]');
      productNotifyForm.classList.add('active');

      const productEnquireNotifySuccess = document.querySelector('[data-product-notify-success]');
      productEnquireNotifySuccess.parentElement.removeChild(productEnquireNotifySuccess);
    })
  }

  const tosCheckbox = document.getElementById('tos_checkbox');
  const checkoutBtn = document.querySelector('.btn.checkout__button');
  if (tosCheckbox) {
    tosCheckbox.addEventListener('change', function() {
      if (tosCheckbox.checked == true)
        checkoutBtn.removeAttribute('disabled');
      else
        checkoutBtn.setAttribute('disabled', 'disabled');
    });
  }

  // Drawer mobile : un click sur le voile sombre (zone hors .drawer__content)
  // ferme le drawer via l'event theme:drawer:close.
  document.querySelectorAll('.header__drawer[data-drawer]').forEach(function(drawerEl) {
    drawerEl.addEventListener('click', function(event) {
      if (event.target !== drawerEl) return;
      if (!drawerEl.classList.contains('drawer--visible')) return;
      drawerEl.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: false }));
    });
  });

  // *** GOOGLE MAP *** //
  var markers = new Array();

  function setMarkers(map) {

    var locations = [
      [
        'BURMA Fine Jewelry',
        48.8688,
        2.3308,
        1,
        '8, rue de la Paix 75002 PARIS',
        'TEL : 00 33 6 75 27 85 30',
        'Ouvert du lundi au samedi',
        'De 10h30 à 18h45'
      ],
      [
        'Burma Capucines',
        48.8709239,
        2.3329469,
        2,
        '8, boulevard des Capucines 75009 PARIS',
        'TEL : 00 33 1 42 66 21 51',
        'capucines@bijouxburma.com',
        'Ouvert du lundi au samedi',
        'De 10h30 à 18h45'
      ],
      [
        'CIRO pour Burma',
        48.871017504869634,
        2.316773674697222,
        3,
        '90, rue du Faubourg Saint-Honoré 75008 PARIS',
        'TEL : 00 33 7 50 65 41 46',
        'Ouvert du lundi au samedi',
        'De 10h30 à 18h45'
      ],
      [
        'Burma François Ier',
        48.8690246,
        2.3033302,
        4,
        '50, rue François Ier 75008 PARIS',
        'TEL : 00 33 1 47 23 70 93',
        'francois1er@bijouxburma.com',
        'Ouvert du lundi au samedi',
        'De 10h30 à 18h30'
      ],
      [
        'Burma Faubourg',
        48.8702664,
        2.3179476,
        6,
        '72, rue du Faubourg Saint-Honoré 75008 PARIS',
        'TEL : 00 33 1 42 65 18 02',
        'faubourg@bijouxburma.com',
        'Ouvert du lundi au samedi',
        'De 10h30 à 18h30'
      ],
      [
        'Burma Saint Honoré',
        48.8661135,
        2.3298543, 5,
        '346, rue Saint-Honoré 75001 PARIS',
        'TEL : 00 33 1 42 96 08 42',
        'sthonore@bijouxburma.com',
        'Ouvert du lundi au samedi',
        'De 10h30 à 18h30'

      ],
      [
        'Burma Cannes',
        43.5511813,
        7.0182417,
        8,
        '20, boulevard de la Croisette 06400 CANNES',
        'TEL : 00 33 4 93 68 67 20',
        'cannes@bijouxburma.com',
        'Ouvert du lundi au samedi',
        'De 10h30 à 18h30'
      ],
      [
        'Burma Monaco',
        43.73333,
        7.41667,
        10,
        '17, avenue des Spélugues - Galerie Métropole - niveau 1 - Boutique 13 98000 MONACO',
        'TEL : 00 377 97 98 33 19',
        'monaco@bijouxburma.com',
        'Ouvert du lundi au samedi',
        'De 10h30 à 18h30'
      ],
      [
        'Burma Genève',
        46.2012,
        6.1469,
        12,
        'Rue Robert-Céard 12, 1204 Genève, Suisse',
        'TEL : 00 41 22 311 06 40',
        'geneve@bijouxburma.com',
        'Ouvert du lundi au vendredi <br>De 10h à 18h30',
        'Le samedi <br>De 10h à 17h'
      ],
      [
        'Burma Dubaï Mall',
        25.1970924,
        55.2790356,
        13,
        'D.M. Fashion Avenue Rez-de-chaussée - 316 DUBAI MALL UNITED ARAB EMIRATES',
        'TEL : 00 971 43 24 69 19',
        'dubaimall@bijouxburma.com',
        'Ouvert du dimanche au mercredi<br>De 10h à 23h',
        'Ouvert du jeudi au samedi<br>De 10h à minuit'
      ]
    ];

    var bounds = new google.maps.LatLngBounds();

    var infowindow;

    for (var i = 0; i < locations.length; i++) {

      var location = locations[i];
      var loc = new google.maps.LatLng(location[1], location[2]);

      var customMapListAddress = document.getElementById('custom_map_list_address');

      // Build the address HTML with conditional email display
      var addressHTML = '<div class="custom_map_list_address_item" data-markerid="' + i + '">' +
        '<div class="address_item_title">' + location[0] + '</div>' +
        '<div>' + location[4] + '<br>' + location[5];

      // Add email only if it exists (check if location[6] contains '@')
      if (location[6] && location[6].indexOf('@') !== -1) {
        addressHTML += '<br>' + location[6];
      }

      // Add opening hours
      addressHTML += '<br>' + location[6 + (location[6] && location[6].indexOf('@') !== -1 ? 1 : 0)];
      addressHTML += '<br><span class="map_color_item">' + location[7 + (location[6] && location[6].indexOf('@') !== -1 ? 1 : 0)] + '</span>';

      // Add second opening hours line if it exists
      var lastIndex = 8 + (location[6] && location[6].indexOf('@') !== -1 ? 1 : 0);
      if (location[lastIndex]) {
        addressHTML += '<br><span class="map_color_item">' + location[lastIndex] + '</span>';
      }

      addressHTML += '</div></div>';
      customMapListAddress.innerHTML += addressHTML;

      bounds.extend(loc);

      // Build the popup content with conditional email display
      var content = '<div class="map_window"><h3>' + location[0] + '</h3><br><p>' + location[4] + '<br>' + location[5];

      // Add email only if it exists (check if location[6] contains '@')
      if (location[6] && location[6].indexOf('@') !== -1) {
        content += '<br>' + location[6];
      }

      // Add opening hours
      content += '<br>' + location[6 + (location[6] && location[6].indexOf('@') !== -1 ? 1 : 0)];
      content += '<br>' + location[7 + (location[6] && location[6].indexOf('@') !== -1 ? 1 : 0)];

      // Add second opening hours line if it exists
      var popupLastIndex = 8 + (location[6] && location[6].indexOf('@') !== -1 ? 1 : 0);
      if (location[popupLastIndex]) {
        content += '<br>' + location[popupLastIndex];
      }

      content += '</p></div>';


      var marker = new google.maps.Marker({

        position: {
          lat: location[1],
          lng: location[2]
        },
        map: map,
        animation: google.maps.Animation.DROP,
        title: location[0],
        zIndex: location[3]
      });

      markers.push(marker);

      google.maps.event.addListener(marker, 'click', (function (marker, content) {


        if (infowindow) {
          infowindow.close();
        }

        infowindow = new google.maps.InfoWindow({
          content: content
        });


        return function () {
          infowindow.setContent(content);
          infowindow.open(map, marker);


          map.setZoom(16);
          map.setCenter(marker.getPosition());
        };

      })(marker, content, infowindow));
    }

    map.fitBounds(bounds);
    map.panToBounds(bounds);

    var customMapAddressContainer = document.getElementById('custom_map_address_container');
    customMapAddressContainer.innerHTML += '<div class="custom_map_list_up_item">&#9650;</div><div class="custom_map_list_down_item">&#9660;</div>';

    const up_arrow = document.querySelector('.custom_map_list_up_item');
    const down_arrow = document.querySelector('.custom_map_list_down_item');
    const map_el = document.querySelector('.custom_map_list_address');
    if(map_el && down_arrow && up_arrow) {
      up_arrow.addEventListener("click", function (e) {
        map_el.scrollTop -= 100;
      });
      down_arrow.addEventListener("click", function (e) {
        map_el.scrollTop += 100;
      });
    }
    
    var items = document.querySelectorAll('.custom_map_list_address_item');
    items.forEach(function(item) {
      item.addEventListener('click', function() {
        var markerId = this.getAttribute('data-markerid');
        google.maps.event.trigger(markers[markerId], 'click');
      });
    });

  }

  function initMap() {

    const burmaLocation = document.getElementById('map_burma_location');
    if(burmaLocation) {
      var map = new google.maps.Map(burmaLocation, {
        zoom: 12,
        center: {
          lat: 48.8709239,
          lng: 2.3329469
        },
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
          position: google.maps.ControlPosition.TOP_LEFT
        },
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        scaleControl: false,
        streetViewControl: true,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        fullscreenControl: true
      });

      setMarkers(map);
    }

  }

  function toggleBounce(marker) {

    if (marker.getAnimation() !== null) {

      marker.setAnimation(null);
    }
    else {

      marker.setAnimation(google.maps.Animation.BOUNCE);
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function () { initMap(); }, 1000);
  });

  // Mini-framework popup, API déclarative via data-attributes :
  // [data-popup-open="<id>"] trigger, [data-popup="<id>"] conteneur,
  // [data-popup-overlay] / [data-popup-close] pour fermer.
  // Focus trap + ESC + scroll lock, une seule popup ouverte à la fois.
  (function() {
    var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),textarea:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';
    var TRANSITION_MS = 300;

    var currentlyOpen = null; // { id, popupEl, previousFocus, onKeydown }

    function getFocusableElements(container) {
      return Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE)).filter(function(el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
      });
    }

    function trapFocus(event, popupEl) {
      if (event.key !== 'Tab') return;
      var focusables = getFocusableElements(popupEl);
      if (focusables.length === 0) {
        event.preventDefault();
        return;
      }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function openPopup(id) {
      if (currentlyOpen) {
        closePopup(currentlyOpen.id);
      }
      var popupEl = document.querySelector('[data-popup="' + id + '"]');
      if (!popupEl) {
        console.warn('[popup] no popup found with id "' + id + '"');
        return;
      }
      var previousFocus = document.activeElement;

      popupEl.removeAttribute('hidden');
      // Force reflow before adding is-open so the transition runs
      void popupEl.offsetHeight;
      popupEl.classList.add('is-open');

      document.body.style.overflow = 'hidden';

      // Focus initial sur le premier élément focusable
      requestAnimationFrame(function() {
        var focusables = getFocusableElements(popupEl);
        if (focusables.length > 0) {
          focusables[0].focus();
        } else {
          popupEl.setAttribute('tabindex', '-1');
          popupEl.focus();
        }
      });

      // Listener keydown : ESC + focus trap
      var onKeydown = function(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closePopup(id);
          return;
        }
        trapFocus(event, popupEl);
      };
      document.addEventListener('keydown', onKeydown);

      currentlyOpen = {
        id: id,
        popupEl: popupEl,
        previousFocus: previousFocus,
        onKeydown: onKeydown
      };
    }

    function closePopup(id) {
      if (!currentlyOpen || currentlyOpen.id !== id) return;
      var state = currentlyOpen;

      state.popupEl.classList.remove('is-open');
      document.removeEventListener('keydown', state.onKeydown);

      setTimeout(function() {
        state.popupEl.setAttribute('hidden', '');
        state.popupEl.removeAttribute('tabindex');
      }, TRANSITION_MS);

      document.body.style.overflow = '';

      // Retour focus sur l'élément qui avait ouvert le popup
      if (state.previousFocus && typeof state.previousFocus.focus === 'function') {
        state.previousFocus.focus();
      }

      currentlyOpen = null;
    }

    function init() {
      // Bind tous les triggers data-popup-open
      var triggers = document.querySelectorAll('[data-popup-open]');
      Array.prototype.forEach.call(triggers, function(trigger) {
        trigger.addEventListener('click', function(event) {
          event.preventDefault();
          var id = trigger.getAttribute('data-popup-open');
          openPopup(id);
        });
      });

      // Bind les boutons close et overlays au moment de l'ouverture (event delegation)
      // car ils sont à l'intérieur de [data-popup] qui est connu à l'init
      var popups = document.querySelectorAll('[data-popup]');
      Array.prototype.forEach.call(popups, function(popupEl) {
        var id = popupEl.getAttribute('data-popup');

        // Click sur l'overlay ferme
        var overlay = popupEl.querySelector('[data-popup-overlay]');
        if (overlay) {
          overlay.addEventListener('click', function() { closePopup(id); });
        }

        // Click sur le bouton close ferme
        var closeButtons = popupEl.querySelectorAll('[data-popup-close]');
        Array.prototype.forEach.call(closeButtons, function(btn) {
          btn.addEventListener('click', function() { closePopup(id); });
        });
      });
    }

    // API globale pour ouvrir/fermer un popup depuis du JS externe.
    // Usage : window.BurmaPopup.open('mon-popup')
    window.BurmaPopup = {
      open: openPopup,
      close: closePopup
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // Wishlist : gérée par l'app Wishify (Zooomy) via son app block
  // injecté dans les templates produit.

})();
